// extracted by mini-css-extract-plugin
module.exports = {"formProductPricesInputWrapper":"InputItem_formProductPricesInputWrapper__pCJA1","formProductPricesInput":"InputItem_formProductPricesInput__nXmHK"};